import { render, staticRenderFns } from "./TypingIndicator.vue?vue&type=template&id=0bb4b9b9"
import script from "./TypingIndicator.vue?vue&type=script&lang=ts"
export * from "./TypingIndicator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports